import { render, staticRenderFns } from "./ArticleFamilyTreeManager.vue?vue&type=template&id=01943251&scoped=true&"
import script from "./ArticleFamilyTreeManager.vue?vue&type=script&lang=js&"
export * from "./ArticleFamilyTreeManager.vue?vue&type=script&lang=js&"
import style0 from "./ArticleFamilyTreeManager.vue?vue&type=style&index=0&id=01943251&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01943251",
  null
  
)

export default component.exports